import { Clear, Search as SearchIcon } from '@mui/icons-material'
import { IconButton, InputAdornment, OutlinedInput } from '@mui/material'
import { useState } from 'react'
import type { useFilters } from 'src/features/scheduledReportSummary/useFilters'

type Props = {
  value: string
  onChange: ReturnType<typeof useFilters>['setFilterOf']['scheduleNameKeyword']
}

/**
 * スケジュール名を部分一致で絞り込むためのテキスト入力欄
 *
 * 入力中の文字列はローカル state で保持し、Enter キー押下または
 * クリアボタン操作時に親へ通知する。レポート一覧の検索欄と同じ UX。
 */
export const ScheduleNameSearchInput = ({ value, onChange }: Props) => {
  const [draftKeyword, setDraftKeyword] = useState(value)
  const [lastSyncedValue, setLastSyncedValue] = useState(value)

  // 外部（URL クエリ等）から value が変わったときに入力欄も追従する。
  // useEffect ではなく render 中に state を調整するパターン。
  // see: https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
  if (value !== lastSyncedValue) {
    setLastSyncedValue(value)
    setDraftKeyword(value)
  }

  const handleClear = () => {
    setDraftKeyword('')
    onChange('')
  }

  return (
    <OutlinedInput
      size="small"
      placeholder="スケジュール名で検索"
      value={draftKeyword}
      onChange={e => setDraftKeyword(e.target.value)}
      onKeyDown={e => {
        if (e.key === 'Enter') onChange(draftKeyword)
      }}
      startAdornment={
        <InputAdornment position="start">
          <SearchIcon fontSize="small" />
        </InputAdornment>
      }
      endAdornment={
        draftKeyword && (
          <InputAdornment position="end">
            <IconButton
              aria-label="検索キーワードをクリア"
              size="small"
              onClick={handleClear}
              edge="end"
            >
              <Clear fontSize="small" />
            </IconButton>
          </InputAdornment>
        )
      }
      sx={{ width: 260 }}
    />
  )
}
